<template>
    <div>
        <v-select
            label="Select Service Code"
            :items="serviceCodes"
            return-object
            item-value="Code"
            item-text="Code"
            v-model="serviceCode"
            @change="$emit('change-service-code', serviceCode)"
            prepend-icon="folder"
            outlined
            dense
            hide-details
            class="rounded-lg"
            background-color="white"
        ></v-select>
    </div>
</template>

<script>
import axios from 'axios';
import { ROLES } from '@/enums/RolesEnum.js'
const url = require("../../client_config/config").url;

export default {
    props: {
        serviceCode: {}
    },

    data: () => ({
        serviceCodes: []
    }),

    created(){
        this.getServiceCodesFromCode();
    },

    methods: 
    {
        getServiceCodesFromCode() {
            const companyIds = localStorage.getItem('userCompanies');
            let State = localStorage.getItem('userState');
            let userRole = localStorage.getItem('userRole');

            if (userRole == ROLES.SUPER_ADMINISTRATOR || userRole == ROLES.ADMINISTRATION) {
                State = '';
            }
            
            axios.get(`${url}/codes`, {
                params: {
                    Company: JSON.parse(companyIds),
                    State: State ? State : ''
                }
            }).then(res => {
                this.serviceCodes = res.data.codes;
            });
        },
    }
}
</script>